/**
 * Maps CMS offer_type color names (v3 design-system) to v4 design-system Tag color values.
 *
 * CMS stores food-themed color names from v3 (e.g. "tomato", "lettuce", "eggplant").
 * v4 Tag component expects: "red" | "success" | "navy-blue" | "purple" | "teal" |
 * "lime-green" | "error" | "info" | "yellow" | "warning" | "grey" | "aqua" | "emerald"
 */

const tagColorMap: Record<string, string> = {
	tomato: "red",
	lettuce: "teal",
	plum: "purple",
	eggplant: "purple",
	mushroom: "grey",
	lemon: "yellow",
	blueberry: "navy-blue",
	lime: "lime-green",
	mint: "aqua",
	basil: "emerald"
};

export function mapTagColor(cmsColor: string): string {
	return tagColorMap[cmsColor] ?? cmsColor;
}
